var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28470_11206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16602 5.41667V6.25C9.16602 6.4801 8.97945 6.66667 8.74935 6.66667H6.66602C4.82509 6.66667 3.33268 8.15903 3.33268 10C3.33268 11.841 4.82509 13.3333 6.66602 13.3333H8.74935C8.97945 13.3333 9.16602 13.5199 9.16602 13.75V14.5833C9.16602 14.8134 8.97945 15 8.74935 15H6.66602C3.90458 15 1.66602 12.7614 1.66602 10C1.66602 7.23857 3.90458 5 6.66602 5H8.74935C8.97945 5 9.16602 5.18656 9.16602 5.41667ZM13.3327 5C16.0941 5 18.3327 7.23857 18.3327 10C18.3327 12.7614 16.0941 15 13.3327 15H11.2493C11.0192 15 10.8327 14.8134 10.8327 14.5833V13.75C10.8327 13.5199 11.0192 13.3333 11.2493 13.3333H13.3327C15.1736 13.3333 16.666 11.841 16.666 10C16.666 8.15903 15.1736 6.66667 13.3327 6.66667H11.2493C11.0192 6.66667 10.8327 6.4801 10.8327 6.25V5.41667C10.8327 5.18656 11.0192 5 11.2493 5H13.3327ZM7.08268 9.16667C6.85258 9.16667 6.66602 9.35323 6.66602 9.58333V10.4167C6.66602 10.6468 6.85258 10.8333 7.08268 10.8333H12.916C13.1461 10.8333 13.3327 10.6468 13.3327 10.4167V9.58333C13.3327 9.35323 13.1461 9.16667 12.916 9.16667H7.08268Z",
    fill: "#567AE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28470_11206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.65005e49.svg";
export { ForwardRef as ReactComponent };